import Vue from 'vue'
import Router from 'vue-router'

import Overview from '@/components/pages/Overview'
import Profile from '@/components/pages/Profile'
import Downloads from '@/components/pages/Downloads'
import Referrals from '@/components/pages/Referrals'
import Transactions from '@/components/pages/Transactions'
import ContactUs from '@/components/pages/ContactUs'
import Login from '@/components/pages/Login'
import Register from '@/components/pages/Register'
import Forgot from '@/components/pages/Forgot'
import Reset from '@/components/pages/Reset'
import Devices from '@/components/pages/Devices'
import Online from '@/components/pages/Online'
import NotFound from '@/components/pages/NotFound'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/overview'
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                disableIfLoggedIn: true
            }
        },
        {
            path: '/sign-up',
            name: 'register',
            component: Register,
            meta: {
                disableIfLoggedIn: true
            }
        },
        {
            path: '/forgot-password',
            name: 'forgot',
            component: Forgot,
            meta: {
                disableIfLoggedIn: true
            }
        },
        {
            path: '/reset-password',
            name: 'reset',
            component: Reset,
            meta: {
                disableIfLoggedIn: true
            }
        },
        {
            path: '/overview',
            meta: { auth: true },
            name: 'overview',
            component: Overview,
        },
        {
            path: '/profile',
            meta: { auth: true },
            name: 'profile',
            component: Profile,
        },
        {
            path: '/downloads',
            meta: { auth: true },
            name: 'downloads',
            component: Downloads,
        },
        {
            path: '/devices',
            meta: { auth: true },
            name: 'devices',
            component: Devices,
        },
        {
            path: '/online',
            meta: { auth: true },
            name: 'online',
            component: Online,
        },
        {
            path: '/transactions',
            meta: { auth: true },
            name: 'transactions',
            component: Transactions,
        },
        {
            path: '/referrals',
            meta: { auth: true },
            name: 'referrals',
            component: Referrals,
        },
        {
            path: '/contact-us',
            meta: { auth: true },
            name: 'contact-us',
            component: ContactUs,
        },
        {
            path: '*',
            meta: { auth: true },
            component: NotFound,
        },
    ],
})

export default router
